import { parserToken } from "./actions";

export function storedb() {
  const self = this || {};
  const Keys = {
    Transaction: "Trans-",
    Alert: "Alert-",
    Kho: "Kho-",
    Store: "Store-",
    Permissions: "Permissions-",
    Menus: "Menus-"
  };

  const string2Json = str => {
    try {
      if (!str) return null;
      return JSON.parse(str);
    } catch (error) {
      return null;
    }
  };

  const init = function() {
    self.info = parserToken(localStorage.getItem("token"));
    
    const key = `${Keys.Menus}${self.info.Username}`
    self.menus = string2Json(localStorage.getItem(key))
  };

  const destroy = function() {
    Object.keys(Keys).forEach(function(prp) {
      const key = Keys[prp] + self.info.Username;
      localStorage.removeItem(key);
    });
  };

  self.setToken = token => {
    // call destroy
    destroy();
    // set a stringified version of our token to localstorage on our domain
    localStorage.setItem("token", JSON.stringify(token));
    init();
    self.setStoreId(token.storeids[0]);
  };

  // get kho id
  self.getSettingValue = function(key, defaultValue) {
    try {
      if (!self.info.Settings || self.info.Settings.length === 0) {
        return defaultValue
      }
      const setting = self.info.Settings.find(x => x.Name === key)
      if (!setting) {
        return defaultValue
      }
      return setting.SettingValue
    } catch (error) {
      console.log(error)
      return defaultValue
    }
  };

  // get kho id
  self.getKhoId = function() {
    const key = Keys.Kho + self.info.Username;
    const khoId = localStorage.getItem(key) || 0;
    if (!isNaN(khoId)) {
      return +khoId
    } else {
      return 0
    }
  };

  // get khos
  self.getKhoIds = function() {
    if (!self.info.Khos || self.info.Khos.length === 0) {
      return [];
    }

    return self.info.Khos.map((item) => { return item.Id })
  };

  // get khos
  self.getKhos = function() {
    if (!self.info.Khos || self.info.Khos.length === 0) {
      return [];
    }

    return self.info.Khos;
  };

  // get permissions
  self.getPermissionsRoles = function() {
    if (!self.info.PermissionsRoles || self.info.PermissionsRoles.length === 0) {
      return [];
    }
    return self.info.PermissionsRoles;
  };

  // getRouteAllowed
  self.getRouteAllowed = function() {
    if (!self.menus || self.menus.length === 0) {
      return [];
    }
    return self.menus;
  };

  // setRouteAllowed
  self.setRouteAllowed = function(value) {
    const key = `${Keys.Menus}${self.info.Username}`
    localStorage.setItem(key, JSON.stringify(value))
    self.menus = value
    return self;
  };

  // get logo
  self.getLogoOfStore = function() {
    if (!self.info.LogoData) {
      return '';
    }
    return self.info.LogoData;
  };

  // get kho name
  self.getKhoName = function() {
    if (!self.info.Khos || self.info.Khos.length === 0) {
      return "";
    }

    const khoId = self.getKhoId() || 0;
    const khoSelection = self.info.Khos.find(x => x.value === khoId) || {};
    return khoSelection.label;
  };

  self.setKhoId = function(value, callback) {
    const key = Keys.Kho + self.info.Username;
    localStorage.setItem(key, value);
    if (typeof callback === "function") {
      callback(self);
    }

    return self;
  };

  // dispatches the CLIENT_UNSET action
  self.getStoreId = function() {
    const key = Keys.Store + self.info.Username;
    const storeId = localStorage.getItem(key) || 0;
    if (!isNaN(storeId)) {
      return +storeId
    } else {
      return 0
    }
  };

  self.setStoreId = function(value, callback) {
    const key = Keys.Store + self.info.Username;
    localStorage.setItem(key, value);
    if (typeof callback === "function") {
      callback(self);
    }

    return self;
  };

  // dispatches the CLIENT_UNSET action
  self.getValue = function(id) {
    const key = Keys.Store + self.info.Username + id
    return localStorage.getItem(key) || ''
  };

  self.setValue = function(id, value) {
    const key = Keys.Store + self.info.Username + id
    localStorage.setItem(key, value)
    return self;
  };

  // dispatches the CLIENT_UNSET action
  self.addTransaction = function(txId, callback) {
    if (!txId || txId.length < 64) {
      return self;
    }

    const key = Keys.Transaction + self.info.Username;
    const txIds = string2Json(localStorage.getItem(key)) || [];
    txIds.push(txId);

    const txIdJson = JSON.stringify(txIds);
    localStorage.setItem(key, txIdJson);

    if (typeof callback === "function") {
      callback(txId);
    }

    return self;
  };

  // /alert = {key, value, text}
  self.addAlert = function(alert, callback) {
    if (!alert) {
      return self;
    }
    const key = Keys.Alert + self.info.Username;
    const alerts = string2Json(localStorage.getItem(key)) || [];

    const index = alerts.findIndex(x => x.key === alert.key);
    if (index !== -1) {
      alerts.splice(index, 1);
    }

    alerts.push(alert);

    const alertJson = JSON.stringify(alerts);
    localStorage.setItem(key, alertJson);

    if (typeof callback === "function") {
      callback(alert);
    }

    return self;
  };

  self.removeTransaction = function(tx, callback) {
    if (!tx || !tx.TxId || tx.TxId.length < 64) {
      return self;
    }
    const key = Keys.Transaction + self.info.Username;
    const txIds = string2Json(localStorage.getItem(key)) || [];

    const index = txIds.indexOf(tx.TxId);
    if (index !== -1) {
      txIds.splice(index, 1);
    }

    const txIdJson = JSON.stringify(txIds);
    localStorage.setItem(key, txIdJson);

    if (typeof callback === "function") {
      callback(tx);
    }

    return self;
  };

  // /alert = {key, value, text}
  // /
  self.removeAlert = function(alert, callback) {
    if (!alert) {
      return self;
    }
    const key = Keys.Alert + self.info.Username;
    const alerts = string2Json(localStorage.getItem(key)) || [];

    const index = alerts.findIndex(x => x.key === alert.key);
    if (index !== -1) {
      alerts.splice(index, 1);
    }

    const alertJson = JSON.stringify(alerts);
    localStorage.setItem(key, alertJson);

    if (typeof callback === "function") {
      callback(alert);
    }

    return self;
  };

  self.getTransactions = function() {
    const key = Keys.Transaction + self.info.Username;
    const txIds = string2Json(localStorage.getItem(key)) || [];
    return txIds.join(";");
  };

  self.getAlerts = function() {
    const key = Keys.Alert + self.info.Username;
    const alerts = string2Json(localStorage.getItem(key)) || [];
    return alerts;
  };

  // dispatches the CLIENT_UNSET action
  self.add = function(interval, callback) {
    let localInterval = interval;
    if (localInterval < 1) {
      localInterval = 1; // second
    }

    self.interval = localInterval * 1000;
    self.func = function() {
      callback();
    };

    return self;
  };

  self.run = function() {
    setInterval(() => {
      self.func();
    }, self.interval);
  };

  self.clearAll = function() {
    destroy();
    localStorage.removeItem("token");
  };

  init();

  return self;
}



// WEBPACK FOOTER //
// ./src/views/client/storedb.js